import React, {useState, useEffect} from "react";

import Box from '@mui/material/Box';

import "../App.css"
import {useAppCtx} from "../app/AppCtx";
import {useCrewCtx} from "../app/CrewCtx";
import {PageHeader} from "./PageHeader";
import {accessCtrl} from "../ctx/AccessCtrl";
import {CxDataGrid} from "../cmx/CxData";
import {CxGrid} from "../cmx/CxGrid";
import {Team} from "../domain/Team";

export function TeamList() {
    const {handleAction} = useAppCtx();
    const {crew, staleloadCrews} = useCrewCtx();

    useEffect(() => {
        staleloadCrews();
    }, []);

    // ----------------------------------------------------------------------------------------------------------------
    // header and view handling
    // ----------------------------------------------------------------------------------------------------------------

    const title = "Gruppen";

    const actionItems = [
        { kind: "icon", label: "Erstellen", iconName: "create", actionName: "teamCreate", disabled:!accessCtrl.canEditTeam }
    ];

    const renderHeader = () => {
        return (
            <PageHeader
                key="team"
                title={title}
                actionItems={actionItems}
            />
        );
    }

    // ----------------------------------------------------------------------------------------------------------------
    // filter view data from cache
    // ----------------------------------------------------------------------------------------------------------------

    const [rows, setRows] = useState([]);

    useEffect(() => {

        const mappedRows = crew.getTeams().map(member => {
            const teamLeadName = crew.getName(member.lead_crew_id);
            const teamNames    = crew.getNames(member.member_crew_ids);

            return {
                ...member,
                teamLeadName,
                teamNames
            };
        });

        setRows(mappedRows);

    }, [crew]);

    // ----------------------------------------------------------------------------------------------------------------
    // render view
    // ----------------------------------------------------------------------------------------------------------------

    const handleRowDoubleClick = (params) => {
        handleAction('teamShow', params.row, 'team');
    };

    const handleEditClick = (params) => {
        handleAction('teamUpdate', params.row, 'team');
    }

    return (
        <Box sx={{ width: '100%' }}>
            <CxGrid container spacing={2}>

                { renderHeader() }

                <CxGrid size="xl">
                    <CxDataGrid
                        rows={rows}
                        columns={Team.getListColumns(false)}
                        onRowDoubleClick={handleRowDoubleClick}
                        onViewAction={handleRowDoubleClick}
                        onEditAction={accessCtrl.canEditTeam ? handleEditClick : undefined} />
                </CxGrid>

            </CxGrid>
        </Box>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// The end.